import React from 'react';
import SubjectPage from '../structure/SubjectPage';
import Accordions from '../../../components/Dropdowns';

const CircuitsandSystems = ({ branch = "CSE", semester = "4th Semester" }) => {
  const accordionContent = [
    <div key="1" className="p-4">
      <p>Signals, Systems and Analysis: Classification of signals and systems, periodic and aperiodic, even and odd, deterministic and random, energy and power signals. continuous time and discrete time, LTI systems, Unit impulse response, Convolution integral and sum. Fourier Series: Trigonometric and Exponential Fourier series, Symmetry properties, Line spectrum. Fourier Transform: Properties, Transform of some standard signals, applications to LTI systems.</p>
    </div>,
    <div key="2" className="p-4">
      <p>Laplace Transform: Definition, Region of Convergence (ROC), Properties, Inverse Laplace transform, Solution of differential equations, System function and stability. State variable analysis: State space representation, state transition matrix, Solution of state equation.</p>
    </div>,
    <div key="3" className="p-4">
      <p>Network Functions and synthesis: Driving point and transfer functions, Poles and Zeros, Stability, Hurwitz polynomial, Positive real functions. Synthesis of one port networks: LC, RC and RL networks, Foster and Cauer forms.</p>
    </div>,
    <div key="4" className="p-4">
      <p>Two Port Networks: Impedance, Admittance, Hybrid, Transmission parameters, Interconnection of two port networks. Filter design: Low pass, High pass, Band pass and Band stop filters, Constant-k and m-derived filters (T and Pi sections).</p>
    </div>
  ];

  const tabData = [
    {
      id: 'syllabus',
      label: 'Syllabus',
      content: <Accordions accordionContent={accordionContent} />,
    },
    {
      id: 'notes',
      label: 'Notes',
      content: null, // Managed by SubjectPage
    },
    {
      id: 'important',
      label: 'Important Questions',
      content: null, // Managed by SubjectPage
    },
    {
      id: 'books',
      label: 'Books',
      content: null, // Managed by SubjectPage
    },
    {
      id: 'PYQ',
      label: 'PYQ',
      content: null, // Managed by SubjectPage
    },
    {
      id: 'videos',
      label: 'Video Lectures',
      content: null, // Managed by SubjectPage
    }
  ];

  return (
    <SubjectPage
      subjectName="Circuits and Systems"
      subjectKey="circuitsandsystems"
      branch={branch}
      semester={semester}
      accordionContent={accordionContent}
      tabData={tabData}
      adminEmail="snaped4338@gmail.com"
      firestoreCollections={{
        notes: 'CircuitsandSystemsNotes',
        videos: 'CircuitsandSystemsVideos'
      }}
    />
  );
};

export default CircuitsandSystems;